import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Svg } from "../svg/Svg";
/*
    NOTE: The polyline child nodes are required
    in this case to support custom CSS hover/focus states
*/
export const SortArrowsIcon = forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "SortArrowsIcon", ...props, ref: ref, children: _jsxs("g", { strokeLinecap: "round", strokeWidth: props.strokeWidth, children: [_jsx("polyline", { fill: "none", stroke: "currentColor", points: "5.5 5.5 8.5 2.5 11.5 5.5" }), _jsx("polyline", { fill: "none", stroke: "currentColor", points: "5.5 10.5 8.5 13.5 11.5 10.5" })] }) })));
SortArrowsIcon.displayName = "SortArrowsIcon";
